import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';

import { getUserData } from '@/utils/authManager';

import IdentityPage from './pages/identity.vue';
import DownloadsPage from './pages/downloads.vue';
import InspirationPage from './pages/inspiration.vue';
import StartPage from './pages/start.vue';
import LogotypePage from './pages/logotype.vue';
import PixelHeadPage from './pages/pixel-head.vue';
import ColorsPage from './pages/colors.vue';
import TypographyPage from './pages/typography.vue';
import TemplatesPage from './pages/templates.vue';
import TemplatesPage2 from './pages/templates2.vue';
import ImagesPage from './pages/images.vue';
import ImagesPage2 from './pages/images2.vue';
import VideosPage from './pages/videos.vue';
import VideosPage2 from './pages/videos2.vue';
import IconsPage from './pages/icons.vue';
import LoginSDK from './pages/login-sdk.vue';
import FormPage from './pages/form.vue';
import MeetingPage from './pages/meeting.vue';
import ListFilesPages from './pages/listfiles.vue';


if (window.location.href.includes('brand.seenthis.co')) {
  window.location = 'https://portal.seenthis.co';
}

const auth = {
  async install() {
    Vue.mixin({
      data() {
        return { GoogleUser: getUserData() };
      },
    });
  },
};
Vue.use(auth);
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history', // https://router.vuejs.org/guide/essentials/history-mode.html
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: '/', component: StartPage },
    { path: '/form', component: FormPage },
    { path: '/identity', component: IdentityPage },
    { path: '/information', component: ListFilesPages },
    { path: '/inspiration', component: InspirationPage },
    { path: '/identity/logotype', component: LogotypePage },
    { path: '/identity/pixel-head', component: PixelHeadPage },
    { path: '/identity/colors', component: ColorsPage },
    { path: '/identity/typography', component: TypographyPage },
    { path: '/identity/templates', component: TemplatesPage2 },
    { path: '/identity/templates2', component: TemplatesPage },
    { path: '/identity/images', component: ImagesPage2 },
    { path: '/identity/images2', component: ImagesPage },
    { path: '/identity/videos', component: VideosPage2 },
    { path: '/identity/videos2', component: VideosPage },
    { path: '/identity/icons', component: IconsPage },
    { path: '/2021-09-21', component: MeetingPage },
    { path: '/2022-02-17', component: MeetingPage },
    { path: '/2022-04-27', component: MeetingPage },
    { path: '/login', component: LoginSDK, name: 'login' },
    { path: '/list', component: DownloadsPage },
  ],
});

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  const queryParams = to.query;
  if (!['login', '/'].includes(to.name)) {
    queryParams.ret = to.path;
  }

  if (!getUserData().validDomain && to.name !== 'login') {
    next({
      name: 'login',
      query: queryParams,
    });
  } else next();
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
